import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ReportData {
  blob: Blob;
  titulo: string;
  nombreArchivo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReportViewerService {

  private reportSubject = new Subject<ReportData>();
  public report$ = this.reportSubject.asObservable();

  constructor() { }

  /**
   * Muestra un PDF en el modal reutilizable
   * @param blob - El blob del PDF generado
   * @param titulo - Título del reporte
   * @param nombreArchivo - Nombre del archivo para descarga (opcional)
   */
  mostrarPDF(blob: Blob, titulo: string, nombreArchivo?: string) {
    const reportData: ReportData = {
      blob,
      titulo,
      nombreArchivo: nombreArchivo || `reporte_${new Date().getTime()}.pdf`
    };

    this.reportSubject.next(reportData);
  }

  /**
   * Cierra el modal (emite null)
   */
  cerrarModal() {
    this.reportSubject.next(null as any);
  }
}
